import { ACADEMY_SCHEDULE, ACADEMY_SCHOOL_SCHEDULE, ACADEMY_SCHEDULE_INFO } from '~/graphql/queries/academySchedule'

const actionTypes = {
  ACADEMY_SCHEDULE: 'ACADEMY_SCHEDULE',
  ACADEMY_SCHOOL_SCHEDULE: 'ACADEMY_SCHOOL_SCHEDULE',
  ACADEMY_SCHEDULE_INFO: 'ACADEMY_SCHEDULE_INFO',
}

const mutationTypes = {
  SET_ACADEMY_SCHEDULE: 'SET_ACADEMY_SCHEDULE',
  SET_LOADING: 'SET_LOADING',
  SET_RANGE_DATE: 'SET_RANGE_DATE',
}

export default {
  state: () => {
    return {
      academySchedule: [],
      isLoading: false,
      rangeDateToJump: {
        startDate: '',
        endDate: '',
      },
    }
  },
  getters: {
    academySchedule: (state) => state.academySchedule,
    isLoading: (state) => state.isLoading,
    rangeDateToJump: (state) => state.rangeDateToJump,
  },
  mutations: {
    [mutationTypes.SET_ACADEMY_SCHEDULE]: (state, academySchedule) => {
      state.academySchedule = academySchedule
    },
    [mutationTypes.SET_LOADING]: (state, isLoading) => {
      state.isLoading = isLoading
    },
    [mutationTypes.SET_RANGE_DATE]: (state, rangeDateToJump) => {
      state.rangeDateToJump = rangeDateToJump
    },
  },
  actions: {
    async [actionTypes.ACADEMY_SCHEDULE]({ commit, dispatch }, { fromDate, toDate, isSetToStore = true }) {
      try {
        if (isSetToStore) {
          commit(mutationTypes.SET_ACADEMY_SCHEDULE, [])
          commit(mutationTypes.SET_LOADING, true)
        }
        const client = this.app.apolloProvider.defaultClient
        const { data } = await client.query({
          query: ACADEMY_SCHEDULE,
          fetchPolicy: 'no-cache',
          variables: { fromDate, toDate },
        })
        if (data && data.academySchedule) {
          if (isSetToStore) {
            commit(
              mutationTypes.SET_ACADEMY_SCHEDULE,
              data.academySchedule.filter(({ course }) => course)
            )
          }
          const ids = data.academySchedule.filter(({ course }) => course).map(({ course }) => course.userId)
          await dispatch('usersInfo/GET_USERS_INFO', { userIds: ids }, { root: true })
        }
        commit(mutationTypes.SET_LOADING, false)
        return data
      } catch (error) {
        commit(mutationTypes.SET_LOADING, false)
        console.error('error', error)
        return error
      }
    },
    async [actionTypes.ACADEMY_SCHOOL_SCHEDULE]({ commit, dispatch, rootState }, { fromDate, toDate }) {
      try {
        commit(mutationTypes.SET_ACADEMY_SCHEDULE, [])
        commit(mutationTypes.SET_LOADING, true)
        const client = this.app.apolloProvider.defaultClient
        await client.resetStore()
        const { schoolProfile } = rootState.school
        const { data } = await client.query({
          query: ACADEMY_SCHOOL_SCHEDULE,
          variables: { fromDate, toDate, schoolId: schoolProfile.id },
        })
        if (data && data.academySchoolSchedule) {
          const academySchoolSchedule = data.academySchoolSchedule.filter((schedule) => schedule.course)
          commit(mutationTypes.SET_ACADEMY_SCHEDULE, academySchoolSchedule)
          const userIds = academySchoolSchedule.map((schedule) => schedule.userId)
          await dispatch('usersInfo/GET_USERS_INFO', { userIds }, { root: true })
        }
        commit(mutationTypes.SET_LOADING, false)
        return data
      } catch (error) {
        commit(mutationTypes.SET_LOADING, false)
        console.error('error', error)
        return error
      }
    },
    async [actionTypes.ACADEMY_SCHEDULE_INFO]({ commit }, slug) {
      try {
        commit(mutationTypes.SET_LOADING, true)
        const client = this.app.apolloProvider.defaultClient
        const { data } = await client.query({
          fetchPolicy: 'no-cache',
          query: ACADEMY_SCHEDULE_INFO,
          variables: { slug },
        })
        commit(mutationTypes.SET_LOADING, false)
        return { data, success: true }
      } catch (error) {
        commit(mutationTypes.SET_LOADING, false)
        return { error, success: false }
      }
    },
  },
}
